import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModuleQueryOptions } from '../models/module-query-options.model';
import { ModuleV1Read } from '../models/module-v1-read.model';
import { DataService } from './abstract-services/data.service';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root',
})
export class ModulesV1Service extends DataService<ModuleV1Read> {
    protected readonly apiUrl: string = '/api/module_manager/v1/';
    constructor(
        protected userService: UserService,
        protected http: HttpClient,
    ) {
        super();
    }

    getSystemModules(): Observable<ModuleV1Read[]> {
        return this.http
            .get(this.apiUrl + 'editor/systemmodules', { headers: { 'Content-Type': 'application/query.api+json' } })
            .pipe(map((res: { data: ModuleV1Read[] }) => res.data.map((module: ModuleV1Read) => new ModuleV1Read(module))));
    }

    getAllVisibleModules(queryOptions: ModuleQueryOptions): Observable<ModuleV1Read[]> {
        let httpParams = new HttpParams()
            .set('search', queryOptions.text ? queryOptions.text : '')
            .set('categoryIds', queryOptions.category ? queryOptions.category : '')
            .set('complianceIds', queryOptions.compliance ? queryOptions.compliance : '')
            .set('sort', queryOptions.sort ? queryOptions.sort : '-createdAt')
            .set('producerId', queryOptions.producer_id ? queryOptions.producer_id : '')
            .set('scope', queryOptions.scope ? queryOptions.scope : '');

        if (queryOptions.isOpenSource != null) {
            httpParams = httpParams.append('isopensource', queryOptions.isOpenSource.toString());
        }
        if (queryOptions.page != null && queryOptions.page.size != null) {
            httpParams = httpParams.append('page[size]', queryOptions.page.size.toString());
        }
        if (queryOptions.page != null && queryOptions.page.number != null) {
            httpParams = httpParams.append('page[number]', queryOptions.page.number.toString());
        }

        httpParams = this.cleanHttpParams(httpParams);
        return this.http
            .get(`/api/module_manager/v1/editor/modules`, {
                params: httpParams,
                headers: { 'Content-Type': 'application/query.api+json' },
            })
            .pipe(map((res: { data: ModuleV1Read[] }) => res.data.map((module: ModuleV1Read) => new ModuleV1Read(module))));
    }

    getPublicModuleById(moduleId: string): Observable<ModuleV1Read> {
        return this.http
            .get(`/api/module_manager/v1/public/modules/${moduleId}`, { headers: { 'Content-Type': 'application/query.api+json' } })
            .pipe(map((res: { data: ModuleV1Read }) => new ModuleV1Read(res.data)));
    }

    getModuleById(moduleId: string): Observable<ModuleV1Read> {
        return this.http
            .get(`/api/module_manager/v1/editor/modules/${moduleId}`, { headers: { 'Content-Type': 'application/query.api+json' } })
            .pipe(map((res: { data: ModuleV1Read }) => new ModuleV1Read(res.data)));
    }

    getSubmittedModuleById(moduleId: string): Observable<ModuleV1Read> {
        return this.http
            .get(`/api/module_manager/v1/admin/modulesubmissions/${moduleId}/module`, { headers: { 'Content-Type': 'application/query.api+json' } })
            .pipe(map((res: { data: ModuleV1Read }) => new ModuleV1Read(res.data)));
    }

    protected createNewInstance(): ModuleV1Read {
        return new ModuleV1Read();
    }
}
